import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { AuthState, AuthUser, Company } from '@/lib/types'
import { tokenStorage } from '@/lib/token-storage'

const initialState: AuthState = {
  user: null,
  company: null,
  token: tokenStorage.getAccess(),
  isAuthenticated: Boolean(tokenStorage.getAccess()),
  isBootstrapped: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<{ access_token: string; remember?: boolean }>) {
      state.token = action.payload.access_token
      state.isAuthenticated = true
      tokenStorage.set(action.payload.access_token, action.payload.remember ?? true)
    },
    setIdentity(state, action: PayloadAction<{ user: AuthUser; company: Company | null }>) {
      state.user = action.payload.user
      state.company = action.payload.company
      state.isBootstrapped = true
      if (action.payload.company) tokenStorage.setCompanyId(action.payload.company.id)
    },
    markBootstrapped(state) {
      state.isBootstrapped = true
    },
    logout(state) {
      state.user = null
      state.company = null
      state.token = null
      state.isAuthenticated = false
      tokenStorage.clear()
    },
  },
})

export const { setCredentials, setIdentity, markBootstrapped, logout } = authSlice.actions
export default authSlice.reducer
